import _asyncToGenerator from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { SafeEventEmitter } from '@toruslabs/openlogin-jrpc';
import { ADAPTER_STATUS, log, CHAIN_NAMESPACES, WalletInitializationError, storageAvailable, getChainConfig, ADAPTER_NAMESPACES, WalletLoginError, ADAPTER_EVENTS } from '@web3auth/base';
import { PLUGIN_NAMESPACES } from '@web3auth/base-plugin';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var ADAPTER_CACHE_KEY = "Web3Auth-cachedAdapter";

var Web3AuthCore = /*#__PURE__*/function (_SafeEventEmitter) {
  _inherits(Web3AuthCore, _SafeEventEmitter);

  function Web3AuthCore(options) {
    var _this;

    _classCallCheck(this, Web3AuthCore);

    var _options$chainConfig, _options$chainConfig2, _options$chainConfig3, _options$chainConfig4;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Web3AuthCore).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "coreOptions", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "connectedAdapterName", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "status", ADAPTER_STATUS.NOT_READY);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cachedAdapter", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "walletAdapters", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "plugins", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "storage", "localStorage");

    if (options.enableLogging) log.enableAll();else log.disableAll();
    if (!((_options$chainConfig = options.chainConfig) !== null && _options$chainConfig !== void 0 && _options$chainConfig.chainNamespace) || !Object.values(CHAIN_NAMESPACES).includes((_options$chainConfig2 = options.chainConfig) === null || _options$chainConfig2 === void 0 ? void 0 : _options$chainConfig2.chainNamespace)) throw WalletInitializationError.invalidParams("Please provide a valid chainNamespace in chainConfig");
    if (options.storageKey === "session") _this.storage = "sessionStorage";
    _this.cachedAdapter = storageAvailable(_this.storage) ? window[_this.storage].getItem(ADAPTER_CACHE_KEY) : null;
    _this.coreOptions = _objectSpread(_objectSpread({}, options), {}, {
      chainConfig: _objectSpread(_objectSpread({}, getChainConfig((_options$chainConfig3 = options.chainConfig) === null || _options$chainConfig3 === void 0 ? void 0 : _options$chainConfig3.chainNamespace, (_options$chainConfig4 = options.chainConfig) === null || _options$chainConfig4 === void 0 ? void 0 : _options$chainConfig4.chainId) || {}), options.chainConfig)
    });
    _this.subscribeToAdapterEvents = _this.subscribeToAdapterEvents.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Web3AuthCore, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;

        var initPromises;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                initPromises = Object.keys(this.walletAdapters).map(function (adapterName) {
                  _this2.subscribeToAdapterEvents(_this2.walletAdapters[adapterName]); // if adapter doesn't have any chain config yet thn set it based on provided namespace and chainId.
                  // if no chainNamespace or chainId is being provided, it will connect with mainnet.


                  if (!_this2.walletAdapters[adapterName].chainConfigProxy) {
                    var providedChainConfig = _this2.coreOptions.chainConfig;
                    if (!providedChainConfig.chainNamespace) throw WalletInitializationError.invalidParams("Please provide chainNamespace in chainConfig");

                    var chainConfig = _objectSpread(_objectSpread({}, getChainConfig(providedChainConfig.chainNamespace, providedChainConfig.chainId)), providedChainConfig);

                    _this2.walletAdapters[adapterName].setChainConfig(chainConfig);
                  }

                  return _this2.walletAdapters[adapterName].init({
                    autoConnect: _this2.cachedAdapter === adapterName
                  }).catch(function (e) {
                    return log.error(e);
                  });
                });
                this.status = ADAPTER_STATUS.READY;
                _context.next = 4;
                return Promise.all(initPromises);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "configureAdapter",
    value: function configureAdapter(adapter) {
      this.checkInitRequirements();
      var providedChainConfig = this.coreOptions.chainConfig;
      if (!providedChainConfig.chainNamespace) throw WalletInitializationError.invalidParams("Please provide chainNamespace in chainConfig");
      var adapterAlreadyExists = this.walletAdapters[adapter.name];
      if (adapterAlreadyExists) throw WalletInitializationError.duplicateAdapterError("Wallet adapter for ".concat(adapter.name, " already exists"));
      if (adapter.adapterNamespace !== ADAPTER_NAMESPACES.MULTICHAIN && adapter.adapterNamespace !== providedChainConfig.chainNamespace) throw WalletInitializationError.incompatibleChainNameSpace("This wallet adapter belongs to ".concat(adapter.adapterNamespace, " which is incompatible with currently used namespace: ").concat(providedChainConfig.chainNamespace));

      if (adapter.adapterNamespace === ADAPTER_NAMESPACES.MULTICHAIN && adapter.currentChainNamespace && providedChainConfig.chainNamespace !== adapter.currentChainNamespace) {
        // chainConfig checks are already validated in constructor so using typecast is safe here.
        adapter.setChainConfig(providedChainConfig);
      }

      this.walletAdapters[adapter.name] = adapter;
      return this;
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      if (!storageAvailable(this.storage)) return;
      window[this.storage].removeItem(ADAPTER_CACHE_KEY);
      this.cachedAdapter = null;
    }
    /**
     * Connect to a specific wallet adapter
     * @param walletName - Key of the walletAdapter to use.
     */

  }, {
    key: "connectTo",
    value: function () {
      var _connectTo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(walletName, loginParams) {
        var provider;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.walletAdapters[walletName]) {
                  _context2.next = 2;
                  break;
                }

                throw WalletInitializationError.notFound("Please add wallet adapter for ".concat(walletName, " wallet, before connecting"));

              case 2:
                _context2.next = 4;
                return this.walletAdapters[walletName].connect(loginParams);

              case 4:
                provider = _context2.sent;
                return _context2.abrupt("return", provider);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function connectTo(_x, _x2) {
        return _connectTo.apply(this, arguments);
      }

      return connectTo;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var options,
            _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {
                  cleanup: false
                };

                if (!(this.status !== ADAPTER_STATUS.CONNECTED || !this.connectedAdapterName)) {
                  _context3.next = 3;
                  break;
                }

                throw WalletLoginError.notConnectedError("No wallet is connected");

              case 3:
                _context3.next = 5;
                return this.walletAdapters[this.connectedAdapterName].disconnect(options);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "getUserInfo",
    value: function () {
      var _getUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                log.debug("Getting user info", this.status, this.connectedAdapterName);

                if (!(this.status !== ADAPTER_STATUS.CONNECTED || !this.connectedAdapterName)) {
                  _context4.next = 3;
                  break;
                }

                throw WalletLoginError.notConnectedError("No wallet is connected");

              case 3:
                return _context4.abrupt("return", this.walletAdapters[this.connectedAdapterName].getUserInfo());

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }()
  }, {
    key: "addPlugin",
    value: function () {
      var _addPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(plugin) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.plugins[plugin.name]) {
                  _context5.next = 2;
                  break;
                }

                throw new Error("Plugin ".concat(plugin.name, " already exist"));

              case 2:
                if (!(plugin.pluginNamespace !== PLUGIN_NAMESPACES.MULTICHAIN && plugin.pluginNamespace !== this.coreOptions.chainConfig.chainNamespace)) {
                  _context5.next = 4;
                  break;
                }

                throw new Error("This plugin belongs to ".concat(plugin.pluginNamespace, " namespace which is incompatible with currently used namespace: ").concat(this.coreOptions.chainConfig.chainNamespace));

              case 4:
                this.plugins[plugin.name] = plugin;
                _context5.next = 7;
                return plugin.initWithWeb3Auth(this);

              case 7:
                return _context5.abrupt("return", this);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function addPlugin(_x3) {
        return _addPlugin.apply(this, arguments);
      }

      return addPlugin;
    }()
  }, {
    key: "subscribeToAdapterEvents",
    value: function subscribeToAdapterEvents(walletAdapter) {
      var _this3 = this;

      walletAdapter.on(ADAPTER_EVENTS.CONNECTED, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data) {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _this3.status = ADAPTER_STATUS.CONNECTED;
                  _this3.connectedAdapterName = data.adapter;

                  _this3.cacheWallet(data.adapter);

                  log.debug("connected", _this3.status, _this3.connectedAdapterName);
                  _context6.next = 6;
                  return Promise.all(Object.values(_this3.plugins).map(function (plugin) {
                    return plugin.connect().catch(function (error) {
                      // swallow error if connector adapter doesn't supports this plugin.
                      if (error.code === 5211) {
                        return;
                      } // throw error;


                      log.error(error);
                    });
                  }));

                case 6:
                  _this3.emit(ADAPTER_EVENTS.CONNECTED, _objectSpread({}, data));

                case 7:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());
      walletAdapter.on(ADAPTER_EVENTS.DISCONNECTED, /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(data) {
          var cachedAdapter;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  // get back to ready state for rehydrating.
                  _this3.status = ADAPTER_STATUS.READY;

                  if (storageAvailable(_this3.storage)) {
                    cachedAdapter = window[_this3.storage].getItem(ADAPTER_CACHE_KEY);

                    if (_this3.connectedAdapterName === cachedAdapter) {
                      _this3.clearCache();
                    }
                  }

                  log.debug("disconnected", _this3.status, _this3.connectedAdapterName);
                  _context7.next = 5;
                  return Promise.all(Object.values(_this3.plugins).map(function (plugin) {
                    return plugin.disconnect().catch(function (error) {
                      // swallow error if adapter doesn't supports this plugin.
                      if (error.code === 5211) {
                        return;
                      } // throw error;


                      log.error(error);
                    });
                  }));

                case 5:
                  _this3.connectedAdapterName = null;

                  _this3.emit(ADAPTER_EVENTS.DISCONNECTED, data);

                case 7:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x5) {
          return _ref2.apply(this, arguments);
        };
      }());
      walletAdapter.on(ADAPTER_EVENTS.CONNECTING, function (data) {
        _this3.status = ADAPTER_STATUS.CONNECTING;

        _this3.emit(ADAPTER_EVENTS.CONNECTING, data);

        log.debug("connecting", _this3.status, _this3.connectedAdapterName);
      });
      walletAdapter.on(ADAPTER_EVENTS.ERRORED, function (data) {
        _this3.status = ADAPTER_STATUS.ERRORED;

        _this3.clearCache();

        _this3.emit(ADAPTER_EVENTS.ERRORED, data);

        log.debug("errored", _this3.status, _this3.connectedAdapterName);
      });
      walletAdapter.on(ADAPTER_EVENTS.ADAPTER_DATA_UPDATED, function (data) {
        log.debug("adapter data updated", data);

        _this3.emit(ADAPTER_EVENTS.ADAPTER_DATA_UPDATED, data);
      });
    }
  }, {
    key: "checkInitRequirements",
    value: function checkInitRequirements() {
      if (this.status === ADAPTER_STATUS.CONNECTING) throw WalletInitializationError.notReady("Already pending connection");
      if (this.status === ADAPTER_STATUS.CONNECTED) throw WalletInitializationError.notReady("Already connected");
      if (this.status === ADAPTER_STATUS.READY) throw WalletInitializationError.notReady("Adapter is already initialized");
    }
  }, {
    key: "cacheWallet",
    value: function cacheWallet(walletName) {
      if (!storageAvailable(this.storage)) return;
      window[this.storage].setItem(ADAPTER_CACHE_KEY, walletName);
      this.cachedAdapter = walletName;
    }
  }, {
    key: "provider",
    get: function get() {
      if (this.status === ADAPTER_STATUS.CONNECTED && this.connectedAdapterName) {
        var adapter = this.walletAdapters[this.connectedAdapterName];
        return adapter.provider;
      }

      return null;
    },
    set: function set(_) {
      throw new Error("Not implemented");
    }
  }]);

  return Web3AuthCore;
}(SafeEventEmitter);

export { Web3AuthCore };